export const FUNCTIONS_NOT_FOUND = 'functions/not-found';
export const AUTH_USER_NOT_FOUND = 'auth/user-not-found';
export const AUTH_WRONG_PASSWORD = 'auth/wrong-password';
export const AUTH_TOO_MANY_REQUESTS = 'auth/too-many-requests';
export const AUTH_INTERNAL_ERROR = 'auth/internal-error';

// custom code for unknown firebase error code -> default 404
export const FIREBASE_NOT_FOUND = 'firebase/not-found';
